import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Badge from '@material-ui/core/Badge';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PaymentInfoButton from 'routes/Payments/PaymentInfoButton';

import { invitationCountSelector as buyerInvitationCountSelector } from 'redux/buyers/selectors';
import { notificationsCountSelector } from 'redux/notifications/selectors';
import { invitationCountSelector as sellerInvitationCountSelector } from 'redux/sellers/selectors';
import { getSelector } from 'redux/selectors';
import { clearSidebarOpen } from 'redux/ui/actions';
import SidebarTopItem from './components/SidebarTopItem';
import Title from './components/Title';
import { isMobile } from 'helpers/detect-mobile';

const styles = () => ({
  acceptBtn: {},
  activeItemText: {
    color: 'inherit',
    fontSize: '0.925rem',
    fontWeight: 500,
    lineHeight: '1.4em',
  },
  item: { padding: '15px 16px 15px 24px' },
  listItemText: { paddingLeft: 0 },
  nestedItem: { padding: '16px 10px 16px 40px' },
  nestedList: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    padding: 0,
  },
  normalItemText: {
    color: 'inherit',
    fontSize: '0.925rem',
    fontWeight: 500,
    lineHeight: '1.4em',
  },
  notificationBadge: {
    backgroundColor: '#ff602e',
    right: 10,
    top: -13,
  },
});

export class Sidebar extends Component {
  static contextTypes = {
    brands: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
    isMember: PropTypes.bool,
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    buyerInvitationCount: PropTypes.number,
    deactivated: PropTypes.bool,
    classes: PropTypes.shape({}).isRequired,
    currentMember: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }),
    sidebarOpen: PropTypes.bool,
    sellerInvitationCount: PropTypes.number,
    sidebarItems: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        name: PropTypes.string,
      }),
    ).isRequired,
    storeNotificationCount: PropTypes.number,
    clearSidebarOpen: PropTypes.func.isRequired,
    buyers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    sellers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
  };

  static defaultProps = {
    buyerInvitationCount: 0,
    currentMember: null,
    currentUser: {},
    deactivated: false,
    history: {},
    sellerInvitationCount: 0,
    sidebarOpen: false,
    storeNotificationCount: 0,
    location: {},
  };

  state = {};

  activeRoute = (routeName) => {
    const { location } = this.props;
    return location.pathname ? location.pathname.indexOf(routeName) > -1 : false;
  }

  handleClick = (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  formatedMenuName = (url, name) => {
    const { isConsumer } = this.context;

    let newName = '';
    if (isMobile && isConsumer) {
      switch (url) {
        case '/track-orders':
          newName = 'Your Orders';
          break;
        case '/order':
          newName = 'Order';
          break;
        case '/vendors':
          newName = 'Vendors';
          break;
        case '/settings':
          newName = 'Profile';
          break;
        case '/marketplace':
          newName = 'Search';
          break;
        default:
          newName = name;
          break;
      }

      return newName;
    }

    return name;
  }

  // nav link
  navLink = (item, idx) => {
    const { brands, currentUser: { organizations }, isConsumer } = this.context;
    const {
      buyerInvitationCount,
      classes,
      deactivated,
      history,
      clearSidebarOpen,
      sellerInvitationCount,
      storeNotificationCount,
    } = this.props;
    const isActiveRoute = this.activeRoute(item.url);
    const pendingInvitationsCount = organizations.filter(o => o.pending).length;

    if (item.title) return <Title {...item} key={idx} />;
    if (item.divider) {
      return (
        <div>
        </div>
      );
    }
    if (item.space) return <div key={idx} className="space" />;
    if (item.children) {
      return (
        <Fragment key={idx}>
          <ListItem>
            {item.leftIcon && (
              <ListItemIcon>{item.leftIcon}</ListItemIcon>
            )}
            <ListItemText inset primary={item.name} />
          </ListItem>
          <Collapse
            classes={{ container: classes.nestedList }}
            in={item.initiallyOpen}
            timeout="auto"
            unmountOnExit
          >
            <List>
              {this.navList(item.children, true)}
            </List>
          </Collapse>
        </Fragment>
      );
    }
    return (
      isConsumer && item.name === 'PayMethodButton' ? (
        <ListItem>
           <PaymentInfoButton/>
        </ListItem>
      ) : (
      <ListItem
        button
        className={item.nested ? 'nested' : ''}
        classes={{ button: classes.item }}
        disabled={deactivated && (item.name !== 'Profile' && item.name !== 'Logout')}
        key={idx}
        onClick={(...args) => {
          clearSidebarOpen();
          if (!item.isNotUrl) {
            history.push(item.url);
            if (item.handleClick) item.handleClick(...args);
          }
        }}
      >
        {
          item.isNotUrl ? item.button : (
            <React.Fragment>
              {item.leftIcon && (
                <ListItemIcon>{item.leftIcon}</ListItemIcon>
              )}
              <ListItemText
                classes={{
                  primary: isActiveRoute ?
                    classes.activeItemText : classes.normalItemText,
                  }}
                primary={this.formatedMenuName(item.url, item.name)}
                style={{ color: isActiveRoute
                    ? brands.navTextColorActive || '#69bfff'
                    : brands.navTextColor || 'white' }
                }
              />
              {item.name === 'Availability Lists' && storeNotificationCount > 0 &&
                <ListItemSecondaryAction>
                  <Badge
                    badgeContent={storeNotificationCount}
                    classes={{ badge: classes.notificationBadge }}
                    color="secondary"
                  >
                    <Typography />
                  </Badge>
                </ListItemSecondaryAction>
              }
              {item.name === 'Customers' && buyerInvitationCount > 0 &&
                <ListItemSecondaryAction>
                  <Badge
                    badgeContent={buyerInvitationCount}
                    classes={{ badge: classes.notificationBadge }}
                    color="secondary"
                  >
                    <Typography />
                  </Badge>
                </ListItemSecondaryAction>
              }
              {item.name === 'Vendors' && sellerInvitationCount > 0 &&
                <ListItemSecondaryAction>
                  <Badge
                    badgeContent={sellerInvitationCount}
                    classes={{ badge: classes.notificationBadge }}
                    color="secondary"
                  >
                    <Typography />
                  </Badge>
                </ListItemSecondaryAction>
              }
            </React.Fragment>
          )
        }
      </ListItem>
      )
    );
  }

  // nav list
  navList = (items, nested) => items.map((item, index) =>
    this.navLink({ ...item, name: item.name || '--', nested }, index));

  render() {
    const { brands, isConsumer } = this.context;
    const {
      currentMember,
      currentUser,
      clearSidebarOpen,
      sidebarOpen,
      sidebarItems,
      history,
      buyers,
      sellers,
    } = this.props;
    // sidebar-nav root

    const listSidebarItems = sidebarItems.toJS().filter(x => !isConsumer || x.name !== 'Payments' || x.name !== 'Search');
    
    //hide Search and Vendor for Customer
    const roleSidebarItems = isConsumer ? listSidebarItems.filter(item => item.name !== 'Search' && item.name !== 'Retail Vendors') : listSidebarItems;
    
    //add PayMethod on left nav for Consumer
    if(isConsumer){
      roleSidebarItems.splice(3, 0, {'name':'PayMethodButton'});
    }

    const drawer = (
      <div>
        <SidebarTopItem
          {...currentUser}
          member={currentMember}
          history={history}
          buyers={buyers}
          sellers={sellers}
        />
        <List className="sidebar-list">
          {this.navList(roleSidebarItems)}
        </List>
      </div>
    );

    return (
      <Drawer
        className="sidebar"
        classes={{ paper: 'sidebar-container' }}
        PaperProps={{
          style: { background: brands.navbarColor },
        }}
        onClose={clearSidebarOpen}
        open={sidebarOpen}
      >
        <SidebarTopItem
          {...currentUser}
          member={currentMember}
          history={history}
          buyers={buyers}
          sellers={sellers}
        />
        <List className="sidebar-list">
          {this.navList(roleSidebarItems)}
        </List>
      </Drawer>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  buyerInvitationCount: buyerInvitationCountSelector(state),
  sellerInvitationCount: sellerInvitationCountSelector(state),
  sidebarItems: getSelector('ui', 'sidebarItems')(state),
  sidebarOpen: getSelector('ui', 'sidebarOpen')(state),
  storeNotificationCount: notificationsCountSelector('store')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  clearSidebarOpen: () => dispatch(clearSidebarOpen()),
});

export default compose(
  setDisplayName('Sidebar'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
)(Sidebar);

